import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import * as moment from 'moment';
import {StaticUtils} from '../../utils/static-utils';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent implements OnInit {
  @Input('color') color: string;
  @Input('placeholder') placeholder: string;
  @Input('isRange') isRange = false;
  @Input('startDate') startDate = moment();
  @Input('endDate') endDate = moment();
  @Input('minDate') minDate: any;
  @Input('maxDate') maxDate: any;
  @Output() onChange = new EventEmitter<any>();
  styles: any;
  options: any;
  label = '';

  constructor() { }

  ngOnInit() {
    this.options = {
      startDate: this.startDate,
      endDate: this.endDate,
      minDate: this.minDate,
      maxDate: this.maxDate,
      autoUpdateInput: false,
      locale: { format: 'DD-MM-YYYY' },
      autoApply: true,
      singleDatePicker: !this.isRange,
      alwaysShowCalendars: true,
      ranges: {
        'Today': [moment(), moment()],
        'Tomorrow': [moment().add(1, 'days'), moment().add(1, 'days')],
        'Next 7 Days': [moment(), moment().add(6, 'days')],
        'Next 30 Days': [moment(), moment().add(29, 'days')],
        'Next 60 Days': [moment(), moment().add(59, 'days')]
        // 'Next 60 Days': [moment().add(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
    };

    switch (this.color) {
      case 'grey':
        this.styles = {
          'background-color': '#f6f6f6'
        };
        break;
      default:
        this.styles = {
          'background-color': '#ffffff'
        };
        break;
    }
  }

  selectedDate(value: any) {
    this.onChange.emit(value);
    if (this.isRange) {
      this.label = StaticUtils.formatDate(value.start) + ' - ' + StaticUtils.formatDate(value.end);
    } else {
      this.label = StaticUtils.formatDate(value.start);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/date-input/date-input.component.ts